// extracted by mini-css-extract-plugin
module.exports = {"bar":"BottomBar_bar__2Rbq-"};